import { useEffect, useState } from "react";
import "../styles/CookieConsent.css";
import { Link } from "react-router-dom";

const STORAGE_KEY = "m3_cookie_choice";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) setVisible(true);
  }, []);

  if (!visible) return null;

  const saveChoice = (choice, detail = null) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice, detail, ts: Date.now() }));
    setVisible(false);
  };

  return (
    <div className="cookie">
      <div className="cookie__card">
        <button className="cookie__close" aria-label="Cerrar" onClick={() => setVisible(false)}>
          ✕
        </button>

        <div className="cookie__title">Cookies</div>
        <p className="cookie__text">
             Usamos cookies para mejorar la experiencia, medir el rendimiento y mostrar contenido.
             Puedes aceptar, rechazar o personalizar. Consulta nuestra{" "}
            <Link className="cookie__link" to="/politica-cookies">
             Política de Cookies
             </Link>
  
        </p>


        {showCustomize && (
          <div className="cookie__custom">
            <label className="cookie__row">
              <input type="checkbox" checked disabled />
              <span>Necesarias (siempre activas)</span>
            </label>
            <label className="cookie__row">
              <input id="analytics" type="checkbox" defaultChecked />
              <span>Analíticas</span>
            </label>
            <label className="cookie__row">
              <input id="marketing" type="checkbox" defaultChecked />
              <span>Marketing</span>
            </label>
          </div>
        )}

        <div className="cookie__actions">
          <button className="cookie__btn ghost" onClick={() => setShowCustomize((v) => !v)}>
            {showCustomize ? "Ocultar" : "Personalizar"}
          </button>

          <button className="cookie__btn ghost" onClick={() => saveChoice("rejected")}>
            Rechazar
          </button>

          <button
            className="cookie__btn primary"
            onClick={() => {
              if (!showCustomize) return saveChoice("accepted");
              const analytics = document.getElementById("analytics")?.checked ?? false;
              const marketing = document.getElementById("marketing")?.checked ?? false;
              saveChoice("custom", { analytics, marketing });
            }}
          >
            {showCustomize ? "Guardar" : "Aceptar"}
          </button>
        </div>
      </div>
    </div>
  );
}
